import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';
import { withBarSelection } from '../../dashboard-helpers';

interface DataType {
  months: LangType[];
  values: {
    data: number[];
    name: LangType;
  }[];
}

export const useReviewsDistributionByTime = (): ChartProps => {
  const { t, getLocale } = useLang();
  const { list } = useDashboardStore();
  const data = list?.feedbacks_by_time as DataType;

  const chartData = useMemo<ReactApexChartProps>(() => {
    if (data) {
      const isDataExists = data?.values.some((item) => item.data.some((value) => value > 0));

      const series = isDataExists
        ? data.values.map(({ name, data }) => ({
            name: getLocale(name),
            data,
          }))
        : [];

      return {
        series,
        options: {
          chart: {
            type: 'bar',
            stacked: true,
            zoom: { enabled: false },
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '8px',
              borderRadius: 4,
            },
          },

          xaxis: {
            categories: data.months.map((month) => getLocale(month)),
          },
          yaxis: [{}],
          colors: ['#28A745', '#DC3545', '#FFC107'], // Green, Red, Yellow
          legend: {
            position: 'bottom',
            horizontalAlign: 'left',
          },
          tooltip: {
            shared: true,
            intersect: false,
            inverseOrder: true,
          },

          dataLabels: {
            enabled: false,
          },
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [data, t]);

  return {
    label: 'Распределение количества отзывов во времени',
    subLabel:
      'Дашборд показывает, в рамках выбранного периода, количество отзывов градированных по оценкам',
    type: 'bar',
    options: withBarSelection(chartData).options,
    series: chartData.series,
  };
};
